import { render } from "./ProjectAddForm.vue?vue&type=template&id=07174678"
import script from "./ProjectAddForm.vue?vue&type=script&lang=js"
export * from "./ProjectAddForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TOP\\Desktop\\vue\\nomad-poc-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__